import React, { useState, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import { useHistory } from 'react-router-dom';
import {createOrganizer} from './organizer_options';
import {signInAdmin, signUpAdmin} from './authentication';

export default function Login({showModal, setShow}) {
    const history = useHistory();
    const show = showModal;
    const handleClose = () => setShow(false);
    const [validated, setValidated] = useState(false);
    const [formState, setFormState] = useState({
        loading: false,
        errorPasswordMessage: ``,
        errorEmailMessage: ``,
      });
    
    const emailRef = useRef();
    const passwordRef = useRef();
    
    const passwordValidation = () => {
        if(passwordRef.current.value.length < 6) {
            setFormState({
                ...formState,
                errorPasswordMessage: 'Password should be at least 6 characters.'
            });
        }
        else {
            setFormState({
                ...formState,
                errorPasswordMessage: ''
            });
        }
    }

    const signUp = (e) => {

        //authenticate user and catch errors
        signUpAdmin(
            emailRef.current.value, 
            passwordRef.current.value
        ).then(user => {
            if(user) createOrganizer(user?.user.uid, user?.user.email)
            history.push("/admin");
        }).catch(err => {
            if(err.code === 'auth/weak-password'){
                setFormState({
                    ...formState,
                    errorPasswordMessage: 'Password should be at least 6 characters.'
                });
            }
            else if(err.code === 'auth/email-already-in-use'){
                setFormState({
                    ...formState,
                    errorEmailMessage: 'Email already in use.'
                });
            }
            else if(err.code === 'auth/invalid-email'){
                setFormState({
                    ...formState,
                    errorEmailMessage: 'Invalid email.'
                });
            }
            console.log(err.message)
        })
    }

    const signIn = (e) => {        
        setFormState({
            ...formState,
            errorEmailMessage: '',
            errorPasswordMessage: ''
        });

        //authenticate user and catch errors
        signInAdmin(
            emailRef.current.value,
            passwordRef.current.value
        ).then(user => {
            console.log(user);
            localStorage.removeItem("currentSession");
            history.push("/admin");
        }).catch(err => {
            if(err.code === 'auth/user-not-found') {
                setFormState({
                    ...formState,
                    errorEmailMessage: 'User doesn\'t exist.'
                });
            }
            else if(err.code === 'auth/invalid-email'){
                setFormState({
                    ...formState,
                    errorEmailMessage: 'Invalid email.'
                });
            }
            else if(err.code === 'auth/user-disabled'){
                setFormState({
                    ...formState,
                    errorEmailMessage: 'User account disabled.'
                });
            }
            else if(err.code === 'auth/wrong-password'){
                setFormState({
                    ...formState,
                    errorPasswordMessage: 'Wrong password.'
                });
            }
            else if(err.code === 'auth/too-many-requests'){
                setFormState({
                    ...formState,
                    errorEmailMessage: 'Access to this account has been temporarily disabled due to too many failed login attempts. Try again later.'
                });
            }
            console.log(err)
        })
    }

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Login</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate onSubmit={handleSubmit}>
                        <Row>
                            <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control ref={emailRef} type="email" placeholder="Enter email" required/>
                            {(validated && formState.errorEmailMessage !== '')? <Form.Control.Feedback type="invalid" className="d-none">
                                {formState.errorEmailMessage}
                            </Form.Control.Feedback> : <Form.Control.Feedback type="invalid" className="d-block">
                                {formState.errorEmailMessage}
                            </Form.Control.Feedback>}
                            </Form.Group>

                            <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control ref={passwordRef} type="password" placeholder="Password" onChange={passwordValidation} required/>
                            {validated && formState.errorPasswordMessage !== ''? <Form.Control.Feedback type="invalid" className="d-none">
                                {formState.errorPasswordMessage}
                            </Form.Control.Feedback> : <Form.Control.Feedback type="invalid" className="d-block">
                                {formState.errorPasswordMessage}
                            </Form.Control.Feedback>}
                            </Form.Group>
                        </Row>
                            <Button variant="secondary" type="submit" value="signUp" onClick={signUp}>
                                Sign Up
                            </Button>
                            <Button variant="primary" type="submit" value="signIn" onClick={signIn}>
                                Sign In
                            </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    )
}
